var _excluded = ["formatHour", "locale", "number"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Mark from './Mark';
import { formatHour as defaultFormatHour } from './shared/hourFormatter';
export default function HourMark(_ref) {
  var _ref$formatHour = _ref.formatHour,
      formatHour = _ref$formatHour === void 0 ? defaultFormatHour : _ref$formatHour,
      locale = _ref.locale,
      number = _ref.number,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Mark, _extends({
    number: number && formatHour(locale, number)
  }, otherProps));
}
HourMark.propTypes = {
  formatHour: PropTypes.func,
  locale: PropTypes.string,
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};